'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _class; // Lib


// Utils


// Actions


// Constants


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = require('react-redux');

var _lodash = require('lodash');

var _dontUpdateForKeys = require('../../utils/milanoteRecompose/dontUpdateForKeys');

var _dontUpdateForKeys2 = _interopRequireDefault(_dontUpdateForKeys);

var _gridSizeSelector = require('../../utils/grid/gridSizeSelector');

var _elementCaptionUtil = require('../../components/caption/elementCaptionUtil');

var _ColumnOnDropDropTarget = require('../column/ColumnOnDropDropTarget');

var _ColumnOnDropDropTarget2 = _interopRequireDefault(_ColumnOnDropDropTarget);

var _columnOnDropConnectDropTarget = require('../column/columnOnDropConnectDropTarget');

var _columnOnDropConnectDropTarget2 = _interopRequireDefault(_columnOnDropConnectDropTarget);

var _elementLineEdgeDropTarget = require('../line/elementLineEdgeDropTarget');

var _elementLineEdgeDropTarget2 = _interopRequireDefault(_elementLineEdgeDropTarget);

var _captionContainerDecorator = require('../../components/caption/captionContainerDecorator');

var _captionContainerDecorator2 = _interopRequireDefault(_captionContainerDecorator);

var _elementActions = require('../../element/elementActions');

var _elementShortcutActions = require('../../element/elementShortcutActions');

var _analytics = require('../../analytics');

var _cardConstants = require('../../../common/cards/cardConstants');

var _boardConstants = require('../../../common/boards/boardConstants');

var _Card = require('./Card');

var _Card2 = _interopRequireDefault(_Card);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dispatchSaveTextContent: function dispatchSaveTextContent(id, textContent) {
            return dispatch((0, _elementActions.updateElement)({ id: id, changes: { textContent: textContent } }));
        },
        createCard: function createCard(_ref) {
            var location = _ref.location,
                currentBoardId = _ref.currentBoardId,
                element = _ref.element;

            (0, _analytics.analyticsEvent)('created-card-cmd-return');

            return dispatch((0, _elementActions.createAndSelectElement)({
                elementType: _cardConstants.CARD_TYPE,
                location: location,
                currentBoardId: currentBoardId,
                content: {
                    caption: (0, _elementCaptionUtil.getCaption)(element),
                    showCaption: (0, _elementCaptionUtil.getShowCaption)(element)
                }
            }));
        },
        dispatchMoveElementToTrash: function dispatchMoveElementToTrash(_ref2) {
            var isEditable = _ref2.isEditable,
                currentBoardId = _ref2.currentBoardId;
            return dispatch((0, _elementShortcutActions.moveElementToTrash)({ isEditable: isEditable, currentBoardId: currentBoardId }));
        }
    };
};

var CardContainer = (_dec = (0, _reactRedux.connect)(_gridSizeSelector.gridSizeSelector, mapDispatchToProps), _dec2 = (0, _dontUpdateForKeys2.default)(['dragModifierKeys', 'canDrop', 'readyToMeasure']), _dec(_class = (0, _ColumnOnDropDropTarget2.default)(_class = (0, _elementLineEdgeDropTarget2.default)(_class = _dec2(_class = (0, _captionContainerDecorator2.default)(_class = function (_React$Component) {
    _inherits(CardContainer, _React$Component);

    function CardContainer(props) {
        _classCallCheck(this, CardContainer);

        var _this = _possibleConstructorReturn(this, (CardContainer.__proto__ || Object.getPrototypeOf(CardContainer)).call(this, props));

        _this.createNewCard = _this.createNewCard.bind(_this);
        _this.createNewCardInList = _this.createNewCardInList.bind(_this);
        _this.saveContent = _this.saveContent.bind(_this);
        _this.moveElementToTrash = _this.moveElementToTrash.bind(_this);
        return _this;
    }

    _createClass(CardContainer, [{
        key: 'createNewCardInList',
        value: function createNewCardInList() {
            var _props = this.props,
                createCard = _props.createCard,
                element = _props.element,
                listIndex = _props.listIndex,
                currentBoardId = _props.currentBoardId;


            var location = {
                parentId: element.getIn(['location', 'parentId']),
                section: _boardConstants.BOARD_SECTIONS.INBOX,
                position: {
                    index: listIndex + 1
                }
            };

            createCard({ location: location, currentBoardId: currentBoardId, element: element });
        }
    }, {
        key: 'createNewCardOnCanvas',
        value: function createNewCardOnCanvas() {
            var _props2 = this.props,
                createCard = _props2.createCard,
                element = _props2.element,
                gridSize = _props2.gridSize,
                currentBoardId = _props2.currentBoardId;


            var thisNode = _reactDom2.default.findDOMNode(this);
            var thisHeight = Math.round(thisNode.offsetHeight / gridSize);

            var location = {
                parentId: element.getIn(['location', 'parentId']),
                section: _boardConstants.BOARD_SECTIONS.CANVAS,
                position: {
                    x: element.getIn(['location', 'position', 'x']),
                    y: element.getIn(['location', 'position', 'y']) + thisHeight + 1
                }
            };

            createCard({ location: location, currentBoardId: currentBoardId, element: element });
        }
    }, {
        key: 'createNewCard',
        value: function createNewCard() {
            var inList = this.props.inList;


            if (inList) {
                this.createNewCardInList();
            } else {
                this.createNewCardOnCanvas();
            }
        }
    }, {
        key: 'saveContent',
        value: function saveContent(textContent) {
            var _props3 = this.props,
                isEditable = _props3.isEditable,
                element = _props3.element,
                dispatchSaveTextContent = _props3.dispatchSaveTextContent;

            if (!isEditable) return;

            dispatchSaveTextContent(element.get('id'), textContent);
        }
    }, {
        key: 'moveElementToTrash',
        value: function moveElementToTrash() {
            this.props.dispatchMoveElementToTrash(this.props);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props4 = this.props,
                connectLineEdgeDropTarget = _props4.connectLineEdgeDropTarget,
                inList = _props4.inList;


            var lineEdgeConnector = connectLineEdgeDropTarget && !inList ? connectLineEdgeDropTarget : _lodash.identity;

            return (0, _columnOnDropConnectDropTarget2.default)(this.props, lineEdgeConnector(_react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_Card2.default, _extends({}, this.props, {
                    saveContent: this.saveContent,
                    createNewCard: this.createNewCard,
                    moveElementToTrash: this.moveElementToTrash }))
            )));
        }
    }]);

    return CardContainer;
}(_react2.default.Component)) || _class) || _class) || _class) || _class) || _class);
exports.default = CardContainer;


CardContainer.propTypes = {
    element: _propTypes2.default.object.isRequired,
    currentBoardId: _propTypes2.default.string.isRequired,
    createCard: _propTypes2.default.func,
    inList: _propTypes2.default.string,
    listIndex: _propTypes2.default.number,
    gridSize: _propTypes2.default.number,
    connectDropTarget: _propTypes2.default.func,
    dispatchSaveTextContent: _propTypes2.default.func,
    dispatchMoveElementToTrash: _propTypes2.default.func,
    isEditable: _propTypes2.default.bool,
    connectLineEdgeDropTarget: _propTypes2.default.func
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/card/CardContainer.js
// module id = 1960
// module chunks = 0